module.exports = __webpack_public_path__ + "img/571696e.png";